import styled, { css } from 'styled-components';

import { defaultThemeProp } from '../../theme';
import FormDialog from '../Dialog/FormDialog';

export const StyledAIRewriteDialog = styled(FormDialog)(({ theme }) => {
  return css`
    min-width: min(${theme.base['content-width'].xl}, calc(100vw - 2rem));
  `;
});

StyledAIRewriteDialog.defaultProps = defaultThemeProp;

export const StyledFormSection = styled.div(({ theme }) => {
  return css`
    background: ${theme.base.palette['secondary-background']};
    border-radius: ${theme.base['border-radius']};
    padding: calc(2 * ${theme.base.spacing});
  `;
});

StyledFormSection.defaultProps = defaultThemeProp;

export const StyledInstructionsWrapper = styled.div`
  textarea {
    min-height: unset;
  }
`;

StyledInstructionsWrapper.defaultProps = defaultThemeProp;
